module.exports = __webpack_public_path__ + "sn.da6a817cd41a3d236371.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sn.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sn.svg
// module chunks = styles